import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useAutoTranslate } from './T';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' }
];


const LanguageSwitcher = () => {
  const at = useAutoTranslate();
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.substring(0, 2) || 'en';
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (langCode) => {
    i18n.changeLanguage(langCode);
    handleClose();
  };

  const current = LANGUAGES.find(l => l.code === currentLang) || LANGUAGES[0];

  return (
    <div>
      <Button
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="text"
        startIcon={<LanguageIcon />}
        style={{
          textTransform: 'uppercase',
          fontWeight: 600,
          color: '#32cd32', // Use theme/brand #32cd32
          borderRadius: '8px',
          padding: '6px 12px',
        }}
      >
        {current.code}
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            minWidth: '140px',
            border: '1px solid rgba(0,0,0,0.05)',
            marginTop: '4px',
          }
        }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === currentLang}
            onClick={() => handleChange(lang.code)}
            style={{
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: 500,
            }}
          >
            <ListItemIcon style={{ minWidth: '28px', fontSize: '15px' }}>
              {lang.flag}
            </ListItemIcon>
            <ListItemText 
              primary={at(lang.label)}
              primaryTypographyProps={{ style: { fontSize: '13px', fontWeight: 500 } }} 
            />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
